import MuiShoppingCart from "@mui/icons-material/ShoppingCart";
import MuiEdit from "@mui/icons-material/Edit";
import MuiSearch from "@mui/icons-material/Search";
import MuiCloseIcon from "@mui/icons-material/Close";
import MuiDeleteOutline from "@mui/icons-material/DeleteOutline";
import MuiInfo from "@mui/icons-material/Info";
import MuiCheck from "@mui/icons-material/Check";
import MuiInfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MuiAddIcon from "@mui/icons-material/AddCircleOutline";
import MuiUndo from "@mui/icons-material/Undo";
import MuiSortByAlpha from "@mui/icons-material/SortByAlpha";
import MuiSortRounded from "@mui/icons-material/SortRounded";
import MuiKeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MuiKeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MuiKeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MuiUnfoldLessDoubleOutlinedIcon from '@mui/icons-material/UnfoldLessDoubleOutlined';
import MuiUnfoldMoreDoubleOutlinedIcon from '@mui/icons-material/UnfoldMoreDoubleOutlined';
import MuiPrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import MuiPictureAsPdfOutlined from "@mui/icons-material/PictureAsPdfOutlined";
import CONFIG from "../../config";

export const ArrowBackIcon = () => {
  return <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root arrow-back" aria-hidden="true" viewBox="0 0 24 24" >
    <circle r="11" cx="12" cy="12" strokeWidth="2" stroke="currentColor"></circle>
    <path
      d="M14.71 15.88 10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
      fill="currentColor"
    >
    </path>
  </svg>;
};

export const ArrowForwardIcon = () => {
  return <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root arrow-forward" aria-hidden="true" viewBox="0 0 24 24" >
    <circle r="11" cx="12" cy="12" strokeWidth="2" stroke="currentColor"></circle>
    <path
      d="M9.29 15.88 13.17 12 9.29 8.12a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42z"
      fill="currentColor"
    >
    </path>
  </svg>;
};

// extending @mui/icons-material/QuestionAnswerOutlined;
export const ChatIcon = (props) => {
  const { children, className, ...attributes } = props || {};
  return <svg
    className={"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root " + className}
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="QuestionAnswerOutlinedIcon"
    {...attributes}
  >
    {children}
    <path
      d="M15 4v7H5.17l-.59.59-.58.58V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1"
    >
    </path>
  </svg>;
};

// extending @mui/icons-material/ScreenShareOutlined;
export const ScreenShareIcon = (props) => {
  const { children, className, ...attributes } = props || {};
  return <svg
    className={"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root " + className}
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="ScreenShareOutlinedIcon"
    {...attributes}
  >
    {children}
    <path
      d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2zM4 16V6h16v10.01zm9-6.87c-3.89.54-5.44 3.2-6 5.87 1.39-1.87 3.22-2.72 6-2.72v2.19l4-3.74L13 7z"
    >
    </path>
  </svg>;
};

// extending @mui/icons-material/ZoomInOutlined
export const MagnifyIcon = (props) => {
  const { children, className, ...attributes } = props || {};
  return <svg
    className={"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium save-contact css-i4bv87-MuiSvgIcon-root " + className}
    focusable="false"
    aria-hidden="false"
    viewBox="0 0 24 24"
    data-testid="ZoomInOutlinedIcon"
    {...attributes}
  >
    {children}
    <path
      d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14m.5-7H9v2H7v1h2v2h1v-2h2V9h-2z"
    >
    </path>
  </svg>;
};

export const ShoppingCartIcon = MuiShoppingCart;
export const EditIcon = MuiEdit;
export const SearchIcon = MuiSearch;
export const CloseIcon = MuiCloseIcon;
export const DeleteIcon = MuiDeleteOutline;
export const InfoIcon = MuiInfo;
export const rageProductInfoIcon = (props) => {
  const { className, ...attributes } = props || {};
  return (
    <svg
      className={"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium " + (className || "")}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      focusable="false"
      aria-hidden="true"
      {...attributes}
    >
      <circle cx="18" cy="18" r="16" fill="none" stroke="#D4005C" strokeWidth="2.5" />
      <circle cx="18" cy="11" r="2.2" fill="#D4005C" />
      <rect x="15.8" y="15" width="4.4" height="12" rx="1.5" fill="#D4005C" />
    </svg>
  );
};

export const VerseneoProductInfoIcon = (props) => {
  const { className, ...attributes } = props || {};
  return (
    <svg
      className={"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium " + (className || "")}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      focusable="false"
      aria-hidden="true"
      {...attributes}
    >
      <circle cx="18" cy="18" r="16" fill="none" stroke="#8CD000" strokeWidth="2.5" />
      <circle cx="18" cy="11" r="2.2" fill="#8CD000" />
      <rect x="15.8" y="15" width="4.4" height="12" rx="1.5" fill="#8CD000" />
    </svg>
  );
};
export const CheckIcon = MuiCheck;
export const InfoOutlinedIcon = MuiInfoOutlinedIcon;
export const AddIcon = MuiAddIcon;
export const UndoIcon = MuiUndo;
export const SortByAlphaIcon = MuiSortByAlpha;
export const SortRoundedIcon = MuiSortRounded;
export const ArrowUpIcon = MuiKeyboardArrowUpIcon;
export const ArrowDownIcon = MuiKeyboardArrowDownIcon;
export const ArrowRightIcon = MuiKeyboardArrowRightIcon;
export const Fold = MuiUnfoldLessDoubleOutlinedIcon;
export const Unfold = MuiUnfoldMoreDoubleOutlinedIcon;
export const PrintIcon = MuiPrintOutlinedIcon;
export const PdfIcon = MuiPictureAsPdfOutlined;

export const getProduktInfoIcon = () => {
  return CONFIG.isVerseNeo() ? VerseneoProductInfoIcon : rageProductInfoIcon;

};

export default {
  ArrowBackIcon,
  ArrowForwardIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowRightIcon,
  Fold,
  Unfold,
  PrintIcon,
  PdfIcon,
  ShoppingCartIcon,
  EditIcon,
  ChatIcon,
  ScreenShareIcon,
  MagnifyIcon,
  SearchIcon,
  CloseIcon,
  DeleteIcon,
  InfoIcon,
  CheckIcon,
  InfoOutlinedIcon,
  AddIcon,
  UndoIcon,
  SortByAlphaIcon,
  SortRoundedIcon,
  rageProductInfoIcon,
  VerseneoProductInfoIcon
};
